import React from 'react';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  totalItems,
  containerStyle,
  activeColor = '#298A84',
  inactiveColor = '#f1f5f9',
  textColor = '#298A84'
}) => {
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;
    
    if (showEllipsis) {
      if (currentPage <= 4) {
        // Show first 5 pages + ellipsis + last page
        for (let i = 1; i <= 5; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        // Show first page + ellipsis + last 5 pages
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i);
      } else {
        // Show first page + ellipsis + current-1, current, current+1 + ellipsis + last page
        pages.push(1);
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    } else {
      // Show all pages if total pages <= 7
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    }
    
    return pages;
  };

  const getDisplayText = () => {
    if (itemsPerPage && totalItems) {
      const start = (currentPage - 1) * itemsPerPage + 1;
      const end = Math.min(currentPage * itemsPerPage, totalItems);
      return `Showing ${start}-${end} of ${totalItems}`;
    }
    return null;
  };

  return (
    <div style={{ padding: '16px', backgroundColor: 'white', ...containerStyle }}>
      {/* Items display text */}
      {getDisplayText() && (
        <div style={{ textAlign: 'center', marginBottom: '12px', fontSize: '14px', color: textColor }}>
          {getDisplayText()}
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {/* Previous button */}
        <button
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            padding: '8px 12px',
            borderRadius: '4px',
            backgroundColor: currentPage === 1 ? '#cbd5e1' : activeColor,
            color: 'white',
            fontSize: '14px',
            fontWeight: '500',
            border: 'none',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
          }}
        >
          Previous
        </button>

        {/* Page numbers */}
        <div style={{ display: 'flex', alignItems: 'center', margin: '0 16px' }}>
          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => typeof page === 'number' && onPageChange(page)}
              disabled={page === '...'}
              style={{
                width: '32px',
                height: '32px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 4px',
                borderRadius: '4px',
                border: 'none',
                backgroundColor: page === '...' 
                  ? 'transparent' 
                  : (typeof page === 'number' && page === currentPage 
                      ? activeColor 
                      : inactiveColor),
                color: typeof page === 'number' && page === currentPage 
                  ? 'white' 
                  : textColor,
                fontSize: '14px',
                fontWeight: typeof page === 'number' && page === currentPage ? '500' : 'normal',
                cursor: page === '...' ? 'default' : 'pointer'
              }}
            >
              {page}
            </button>
          ))}
        </div>

        {/* Next button */}
        <button
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            padding: '8px 12px',
            borderRadius: '4px',
            backgroundColor: currentPage === totalPages ? '#cbd5e1' : activeColor,
            color: 'white',
            fontSize: '14px',
            fontWeight: '500',
            border: 'none',
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;